export const isDev = (env: string) => {
  return env === 'development';
};

export const isDevClientSide = () => {
  const devEnvs = ['dev', 'development', 'testing'];
  const activeEnv = process.env.EARNUP_APP_EARNUP_ENV ?? 'development';
  return devEnvs.includes(activeEnv);
};
